enum CostumeTextureID {
  // Backgrounds
  BackgroundCaffe,
  BackgroundLivingRoom,
  BackgroundJapaneseRoom,
  BackgroundAquarium,
  BackgroundAmusementPark1,
  BackgroundAmusementPark2,
  BackgroundFlowerGarden,
  BackgroundClassRoom,
  BackgroundNightView,
  BackgroundNightSky,
  BackgroundSpring,
  BackgroundSummer1,
  BackgroundSummer2,
  BackgroundSummer3,
  BackgroundFall1,
  BackgroundFall2,
  BackgroundWinter1,
  BackgroundWinter2,
  BackgroundSpace,
  // Back hairs
  HairBackNormal,
  HairBackTied,
  HairBackFurisode,
  HairBackBraidMaid,
  HairBackBraidShort,
  HairBackBrushedUp,
  HairBackAku,
  // Clothes
  ClothesNormal,
  ClothesSummer,
  ClothesSchool,
  ClothesFurisode,
  ClothesFurisodeWithShawl,
  ClothesMaid,
  ClothesWhiteTurtleneck,
  ClothesBlackShirt,
  ClothesBlackShirtWithSacoche,
  ClothesAku,
  // Hair shadows
  HairShadowNormal,
  HairShadowTied,
  HairShadowFurisode,
  HairShadowBraidMaid,
  HairShadowBraidShort,
  HairShadowBrushedUp,
  HairShadowAku,
  // Front hairs
  HairFrontNormal,
  HairFrontTied,
  HairFrontFurisode,
  HairFrontBraidMaid,
  HairFrontBraidShort,
  HairFrontBrushedUp,
  HairFrontAku,
  // Eyebrows
  EyebrowsNormal,
  EyebrowsNormalAku,
  EyebrowsSmile,
  EyebrowsSmileAku,
  EyebrowsAngry,
  EyebrowsAngryAku,
  EyebrowsSad,
  EyebrowsSadAku,
  EyebrowsSmug,
  EyebrowsSmugAku,
  EyebrowsTroubled,
  EyebrowsTroubledAku,
  // Eyes
  EyesNormal,
  EyesNormalAlpha,
  EyesNormalAku,
  EyesNormalAkuAlpha,
  EyesSurprised,
  EyesSurprisedAlpha,
  EyesSurprisedAku,
  EyesSurprisedAkuAlpha,
  EyesUpper,
  EyesUpperAlpha,
  EyesUpperAku,
  EyesUpperAkuAlpha,
  EyesSlightlyClosed,
  EyesSlightlyClosedAlpha,
  EyesSlightlyClosedAku,
  EyesSlightlyClosedAkuAlpha,
  EyesScornful,
  EyesScornfulAlpha,
  EyesScornfulAku,
  EyesScornfulAkuAlpha,
  EyesDowncast,
  EyesDowncastAlpha,
  EyesDowncastAku,
  EyesDowncastAkuAlpha,
  EyesClosedSilent,
  EyesClosedSilentAlpha,
  EyesClosedSilentAku,
  EyesClosedSilentAkuAlpha,
  EyesClosedSmile,
  EyesClosedSmileAlpha,
  EyesClosedSmileAku,
  EyesClosedSmileAkuAlpha,
  EyesArrow,
  EyesArrowAlpha,
  EyesArrowAku,
  EyesArrowAkuAlpha,
  EyesShitake,
  EyesShitakeAlpha,
  EyesShitakeAku,
  EyesShitakeAkuAlpha,
  EyesRightWink1,
  EyesRightWink1Alpha,
  EyesRightWink1Aku,
  EyesRightWink1AkuAlpha,
  EyesLeftWink1,
  EyesLeftWink1Alpha,
  EyesLeftWink1Aku,
  EyesLeftWink1AkuAlpha,
  EyesRightWink2,
  EyesRightWink2Alpha,
  EyesRightWink2Aku,
  EyesRightWink2AkuAlpha,
  EyesLeftWink2,
  EyesLeftWink2Alpha,
  EyesLeftWink2Aku,
  EyesLeftWink2AkuAlpha,
  // Mouth
  MouthClosed,
  MouthSlightlyOpened,
  MouthOpened,
  MouthWidelyOpened,
  MouthWhite,
  MouthCat,
  MouthWithTongue,
  MouthAngry,
  MouthStupified,
  MouthGrin,
  MouthBlank,
  MouthStronglyClothed,
  MouthWaved,
  MouthDot,
  MouthVampire,
  // Arms
  ArmsByeNormal,
  ArmsByeSummer,
  ArmsByeSchool,
  ArmsByeFurisode,
  ArmsByeFurisodeWithShawl,
  ArmsByeMaid,
  ArmsByeWhiteTurtleneck,
  ArmsByeBlackShirt,
  ArmsByeBlackShirtWithSacoche,
  ArmsByeAku,

  ArmsPenNormal,
  ArmsPenSummer,
  ArmsPenSchool,
  ArmsPenFurisode,
  ArmsPenFurisodeWithShawl,
  ArmsPenMaid,
  ArmsPenWhiteTurtleneck,
  ArmsPenBlackShirt,
  ArmsPenBlackShirtWithSacoche,
  ArmsPenAku,

  ArmsCatNormal,
  ArmsCatSummer,
  ArmsCatSchool,
  ArmsCatFurisode,
  ArmsCatFurisodeWithShawl,
  ArmsCatMaid,
  ArmsCatWhiteTurtleneck,
  ArmsCatBlackShirt,
  ArmsCatBlackShirtWithSacoche,
  ArmsCatAku,

  ArmsGaoNormal,
  ArmsGaoSummer,
  ArmsGaoSchool,
  ArmsGaoFurisode,
  ArmsGaoFurisodeWithShawl,
  ArmsGaoMaid,
  ArmsGaoWhiteTurtleneck,
  ArmsGaoBlackShirt,
  ArmsGaoBlackShirtWithSacoche,
  ArmsGaoAku,

  ArmsIndexFingerNormal,
  ArmsIndexFingerSummer,
  ArmsIndexFingerSchool,
  ArmsIndexFingerFurisode,
  ArmsIndexFingerFurisodeWithShawl,
  ArmsIndexFingerMaid,
  ArmsIndexFingerWhiteTurtleneck,
  ArmsIndexFingerBlackShirt,
  ArmsIndexFingerBlackShirtWithSacoche,
  ArmsIndexFingerAku,

  ArmsToMouthNormal,
  ArmsToMouthSummer,
  ArmsToMouthSchool,
  ArmsToMouthFurisode,
  ArmsToMouthFurisodeWithShawl,
  ArmsToMouthMaid,
  ArmsToMouthWhiteTurtleneck,
  ArmsToMouthBlackShirt,
  ArmsToMouthBlackShirtWithSacoche,
  ArmsToMouthAku,

  ArmsHeart,

  ArmsAkinium,

  // Caps
  CapWhiteLining, // 裏地

  CapWhiteNormal,
  CapWhiteTied,
  CapWhiteFurisode,
  CapWhiteBraidMaid,
  CapWhiteBraidShort,
  CapWhiteBrushedUp,
  CapWhiteAku,

  CapSchoolNormal,
  CapSchoolTied,
  CapSchoolFurisode,
  CapSchoolBraidMaid,
  CapSchoolBraidShort,
  CapSchoolBrushedUp,
  CapSchoolAku,

  CapCasquetteNormal,
  CapCasquetteTied,
  CapCasquetteFurisode,
  CapCasquetteBraidMaid,
  CapCasquetteBraidShort,
  CapCasquetteBrushedUp,
  CapCasquetteAku,

  CapHeaddressNormal,
  CapHeaddressTied,
  CapHeaddressFurisode,
  CapHeaddressBraidMaid,
  CapHeaddressBraidShort,
  CapHeaddressBrushedUp,
  CapHeaddressAku,

  CapHalloween,
  // Glasses
  Glasses,
  GlassesCinnamoroll,
  // Earrings
  EarringsVampire,
  EarringsFur,
  // Accessories
  AccessoryCrown,
  AccessoryAngryMark,
  AccessoryTeardrop,
  AccessoryMicrophone,
  AccessoryHairpinsVampire,
  AccessoryHairpin,
  AccessorySparkle,
  AccessoryHearts,
  AccessoryHead,
  AccessoryWing,
  AccessoryCheek1,
  AccessoryCheek2,
  AccessoryCheek3,
  // Body
  Body,
}

type CostumeTextureSet = Set<CostumeTextureID>;

interface CostumeTextureInfo {
  path: string;
  priority: number;
  alpha?: number;
}

type CostumeTextureRegistry = { [key in CostumeTextureID]: CostumeTextureInfo };

const BackgroundPriority = 0;
const HairBackPriority = 20;
const BodyPriority = 30;
const ClothesPriority = 40;
const HairShadowPriority = 50;
const EarringPriority = 55;
const EyePriority = 60;
const MouthPriority = 60;
const HairFrontPriority = 70;
const EyeAlphaPriority = 75;
const ArmPriority = 80;
const EyebrowPriority = 80;
const CapPriority = 90;
const AccessoryPriority = 100;

const costumeTextureRegistry: CostumeTextureRegistry = {
  // Backgrounds
  [CostumeTextureID.BackgroundCaffe]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_001.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundLivingRoom]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_002.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundJapaneseRoom]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_003.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundAquarium]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_004.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundAmusementPark1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_005.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundAmusementPark2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_006.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundFlowerGarden]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_007.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundClassRoom]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_008.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundNightView]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_009.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundNightSky]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_010.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundSpring]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_011.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundSummer1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_012.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundSummer2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_013.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundSummer3]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_014.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundFall1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_015.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundFall2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_016.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundWinter1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_017.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundWinter2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_018.jpg`,
    priority: BackgroundPriority,
  },
  [CostumeTextureID.BackgroundSpace]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/background_019.jpg`,
    priority: BackgroundPriority,
  },
  // Clothes
  [CostumeTextureID.ClothesNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_01.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_02.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_03.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_04.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_05.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_06.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_07.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_08.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_09.png`,
    priority: ClothesPriority,
  },
  [CostumeTextureID.ClothesAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/fuku_10.png`,
    priority: ClothesPriority,
  },
  // Back hairs
  [CostumeTextureID.HairBackNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_01_back.png`,
    priority: HairBackPriority,
  },
  [CostumeTextureID.HairBackTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_02_back.png`,
    priority: HairBackPriority,
  },
  [CostumeTextureID.HairBackFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_03_back.png`,
    priority: HairBackPriority,
  },
  [CostumeTextureID.HairBackBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_04_back.png`,
    priority: HairBackPriority,
  },
  [CostumeTextureID.HairBackBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_05_back.png`,
    priority: HairBackPriority,
  },
  [CostumeTextureID.HairBackBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_06_back.png`,
    priority: HairBackPriority,
  },
  [CostumeTextureID.HairBackAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_07_back.png`,
    priority: HairBackPriority,
  },
  // Hair shadows
  [CostumeTextureID.HairShadowNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_01_shadow.png`,
    priority: HairShadowPriority,
  },
  [CostumeTextureID.HairShadowTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_02_shadow.png`,
    priority: HairShadowPriority,
  },
  [CostumeTextureID.HairShadowFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_03_shadow.png`,
    priority: HairShadowPriority,
  },
  [CostumeTextureID.HairShadowBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_04_shadow.png`,
    priority: HairShadowPriority,
  },
  [CostumeTextureID.HairShadowBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_05_shadow.png`,
    priority: HairShadowPriority,
  },
  [CostumeTextureID.HairShadowBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_06_shadow.png`,
    priority: HairShadowPriority,
  },
  [CostumeTextureID.HairShadowAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_07_shadow.png`,
    priority: HairShadowPriority,
  },
  // Front hairs
  [CostumeTextureID.HairFrontNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_01_front.png`,
    priority: HairFrontPriority,
  },
  [CostumeTextureID.HairFrontTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_02_front.png`,
    priority: HairFrontPriority,
  },
  [CostumeTextureID.HairFrontFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_03_front.png`,
    priority: HairFrontPriority,
  },
  [CostumeTextureID.HairFrontBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_04_front.png`,
    priority: HairFrontPriority,
  },
  [CostumeTextureID.HairFrontBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_05_front.png`,
    priority: HairFrontPriority,
  },
  [CostumeTextureID.HairFrontBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_06_front.png`,
    priority: HairFrontPriority,
  },
  [CostumeTextureID.HairFrontAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/hair_07_front.png`,
    priority: HairFrontPriority,
  },
  // Eyebrows
  [CostumeTextureID.EyebrowsNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_01.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsNormalAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_01_aku.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsSmile]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_02.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsSmileAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_02_aku.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsAngry]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_03.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsAngryAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_03_aku.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsSad]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_04.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsSadAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_04_aku.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsSmug]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_05.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsSmugAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_05_aku.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsTroubled]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_06.png`,
    priority: EyebrowPriority,
  },
  [CostumeTextureID.EyebrowsTroubledAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/mayu_06_aku.png`,
    priority: EyebrowPriority,
  },
  // Eyes
  [CostumeTextureID.EyesNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_01.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesNormalAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_01.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesNormalAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_01_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesNormalAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_01_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesSurprised]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_02.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesSurprisedAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_02.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesSurprisedAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_02_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesSurprisedAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_02_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesUpper]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_03.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesUpperAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_03.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesUpperAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_03_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesUpperAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_03_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesSlightlyClosed]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_04.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesSlightlyClosedAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_04.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesSlightlyClosedAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_04_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesSlightlyClosedAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_04_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesScornful]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_05.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesScornfulAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_05.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesScornfulAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_05_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesScornfulAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_05_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesDowncast]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_06.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesDowncastAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_06.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesDowncastAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_06_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesDowncastAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_06_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesClosedSilent]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_07.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesClosedSilentAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_07.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesClosedSilentAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_07_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesClosedSilentAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_07_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesClosedSmile]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_08.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesClosedSmileAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_08.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesClosedSmileAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_08_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesClosedSmileAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_08_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesArrow]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_09.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesArrowAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_09.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesArrowAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_09_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesArrowAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_09_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },

  [CostumeTextureID.EyesShitake]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_10.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesShitakeAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_10.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesShitakeAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_10_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesShitakeAkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_10_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },

  [CostumeTextureID.EyesRightWink1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_11.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesRightWink1Alpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_11.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesRightWink1Aku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_11_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesRightWink1AkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_11_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },

  [CostumeTextureID.EyesLeftWink1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_12.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesLeftWink1Alpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_12.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesLeftWink1Aku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_12_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesLeftWink1AkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_12_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },

  [CostumeTextureID.EyesRightWink2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_13.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesRightWink2Alpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_13.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesRightWink2Aku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_13_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesRightWink2AkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_13_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },

  [CostumeTextureID.EyesLeftWink2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_14.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesLeftWink2Alpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_14.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },
  [CostumeTextureID.EyesLeftWink2Aku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_14_aku.png`,
    priority: EyePriority,
  },
  [CostumeTextureID.EyesLeftWink2AkuAlpha]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/eye_14_aku.png`,
    priority: EyeAlphaPriority,
    alpha: 0.3,
  },

  // Mouth
  [CostumeTextureID.MouthClosed]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_01.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthSlightlyOpened]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_02.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthOpened]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_03.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthWidelyOpened]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_04.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthWhite]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_05.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthCat]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_06.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthWithTongue]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_07.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthAngry]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_08.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthStupified]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_09.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthGrin]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_10.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthBlank]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_11.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthStronglyClothed]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_12.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthWaved]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_13.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthDot]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_14.png`,
    priority: MouthPriority,
  },
  [CostumeTextureID.MouthVampire]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/kuchi_15.png`,
    priority: MouthPriority,
  },

  //--------------------------------------------------
  // Arms
  //--------------------------------------------------
  [CostumeTextureID.ArmsByeNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_01.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_02.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_03.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_06.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_07.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsByeAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_01_fuku_10.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsPenNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_01.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_02.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_03.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_06.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_07.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsPenAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_02_fuku_10.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsCatNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_01.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_02.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_03.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_06.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_07.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsCatAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_03_fuku_10.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsGaoNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_01.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_02.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_03.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_06.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_07.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsGaoAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_04_fuku_10.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsIndexFingerNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_01.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_02.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_03.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_06.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_07.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsIndexFingerAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_05_fuku_10.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsToMouthNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_01.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthSummer]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_02.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthSchool]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_03.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthFurisodeWithShawl]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_04.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_06.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthWhiteTurtleneck]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_07.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthBlackShirt]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthBlackShirtWithSacoche]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_08.png`,
    priority: ArmPriority,
  },
  [CostumeTextureID.ArmsToMouthAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_06_fuku_10.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsHeart]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_07_fuku_01.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.ArmsAkinium]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/ude_08_fuku_01.png`,
    priority: ArmPriority,
  },

  //--------------------------------------------------
  // Caps
  //--------------------------------------------------
  [CostumeTextureID.CapWhiteLining]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_back.png`,
    priority: HairBackPriority - 1,
  },

  //--------------------------------------------------
  [CostumeTextureID.CapWhiteNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_01.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapWhiteTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_02.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapWhiteFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_03.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapWhiteBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_04.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapWhiteBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_05.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapWhiteBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_06.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapWhiteAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_01_haia_07.png`,
    priority: CapPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.CapSchoolNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_01.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapSchoolTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_02.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapSchoolFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_03.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapSchoolBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_04.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapSchoolBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_05.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapSchoolBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_06.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapSchoolAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_02_haia_07.png`,
    priority: CapPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.CapCasquetteNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_01.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapCasquetteTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_02.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapCasquetteFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_03.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapCasquetteBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_04.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapCasquetteBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_05.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapCasquetteBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_06.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapCasquetteAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_03_haia_07.png`,
    priority: CapPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.CapHeaddressNormal]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_01.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapHeaddressTied]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_02.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapHeaddressFurisode]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_03.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapHeaddressBraidMaid]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_04.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapHeaddressBraidShort]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_05.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapHeaddressBrushedUp]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_06.png`,
    priority: CapPriority,
  },
  [CostumeTextureID.CapHeaddressAku]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_04_haia_07.png`,
    priority: CapPriority,
  },

  //--------------------------------------------------
  [CostumeTextureID.CapHalloween]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/cap_05_haia_01.png`,
    priority: CapPriority,
  },

  //--------------------------------------------------
  // Earrings
  //--------------------------------------------------
  [CostumeTextureID.EarringsVampire]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_07.png`,
    priority: EarringPriority,
  },
  [CostumeTextureID.EarringsFur]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_10.png`,
    priority: EarringPriority,
  },
  // Glasses
  [CostumeTextureID.Glasses]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_02.png`,
    priority: AccessoryPriority,
  },
  [CostumeTextureID.GlassesCinnamoroll]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_03.png`,
    priority: AccessoryPriority,
  },
  // Accessories
  [CostumeTextureID.AccessoryCrown]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_01.png`,
    priority: AccessoryPriority,
  },
  [CostumeTextureID.AccessoryAngryMark]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_04.png`,
    priority: AccessoryPriority,
  },
  [CostumeTextureID.AccessoryTeardrop]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_05.png`,
    priority: HairFrontPriority + 1,
  },
  [CostumeTextureID.AccessoryMicrophone]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_06.png`,
    priority: HairFrontPriority - 1,
  },

  [CostumeTextureID.AccessoryHairpinsVampire]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_08.png`,
    priority: AccessoryPriority,
  },
  [CostumeTextureID.AccessoryHairpin]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_16.png`,
    priority: AccessoryPriority,
  },
  [CostumeTextureID.AccessorySparkle]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_09.png`,
    priority: AccessoryPriority + 10,
  },
  [CostumeTextureID.AccessoryHead]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_11.png`,
    priority: AccessoryPriority + 5,
  },
  [CostumeTextureID.AccessoryWing]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_17.png`,
    priority: BackgroundPriority + 5,
  },
  [CostumeTextureID.AccessoryCheek1]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_12.png`,
    priority: EyePriority - 1,
  },
  [CostumeTextureID.AccessoryCheek2]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_13.png`,
    priority: EyePriority - 1,
  },
  [CostumeTextureID.AccessoryCheek3]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_14.png`,
    priority: EyePriority - 1,
  },
  [CostumeTextureID.AccessoryHearts]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/accessory_15.png`,
    priority: AccessoryPriority + 10,
  },
  // Body
  [CostumeTextureID.Body]: {
    path: `${process.env.PUBLIC_URL}/img/costumes/base.png`,
    priority: BodyPriority,
  },
};

export { costumeTextureRegistry, CostumeTextureID };
export type { CostumeTextureSet, CostumeTextureRegistry, CostumeTextureInfo };
